import type { FaireProductEntity } from "../../entity_types/product";

export const p_n9k9kn3ck2: FaireProductEntity = {
  token: "p_n9k9kn3ck2",
  type: "product",
  name: "Matcha – Candle Jar, 10 oz",
  brandToken: "b_1nj4tujogn",
  brandName: "EMME nyc",
  imageUrl:
    "https://cdn.faire.com/fastly/1a6a5ff76c274376c334229bbf9396894cb39c018e7c5b5a38eb51ffb2c20d50.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/5460c536a5c21bb85f450fb3c5ffed8b8288acf8ccba6b6ef07aa3bd46224a8a.png",
    "https://cdn.faire.com/fastly/e6f815e4bd73490a10cd0fc9c4a027d5e8f043759f71ccaf9384673d891d7d0f.png",
    "https://cdn.faire.com/fastly/b9999dcfd93edf4aff604ab0797ea26b048e9e57771f58af5a6bcb85a2984414.png",
    "https://cdn.faire.com/fastly/8fc1acc6bc22ec863ed488c58718a1456890d9aa401f65abe562a5c2dee98aab.png",
  ],
  priceDollars: 19,
  description:
    "Earthy and luscious, our Matcha fragrance is reminiscent of the perfect green tea latte. The robust notes of matcha are rounded out with pure honey and cream.\n\nMood: Earthy & lucious\nSmells Like: Matcha, Honey, Cream",
  tags: [],
  msrpDollars: 38,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:52:06.240Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
